import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import {
    GET_SET_DETAILS_SUCCESS,
    GET_SET_DETAILS_FAILURE,
} from '../actions';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getSetDetailsSaga(action) {
    const requestPayload = action?.payload || {};
    const baseSiteID = localStorage.getItem('baseSiteId');
    const encodedBatchNo = encodeURIComponent(requestPayload.batchNo || requestPayload.batchId || '');
    const encodedSetNo = encodeURIComponent(requestPayload.setNo || '');
    const url = `/occ/v2/${baseSiteID}/dashboard/getSetDetails?batchNo=${encodedBatchNo}&setNo=${encodedSetNo}`;

    try {
        const result = yield axios.get(url).then((response) => response.data);

        yield put({ type: GET_SET_DETAILS_SUCCESS, payload: result });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: {
                batchNo: requestPayload.batchNo || requestPayload.batchId,
                setNo: requestPayload.setNo,
            },
        });
        yield put({
            type: GET_SET_DETAILS_FAILURE,
            payload: { error: errorHandler('503') },
        });
    }
}